import { datadogRum } from '@datadog/browser-rum';
import {
  identify,
  initialize as initAnalytics,
  routeChangeHandler,
} from '@side/analytics';
import { useSession } from '@side/next-auth/react';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

initAnalytics({ app: 'identity-ui' });

export function AnalyticsIdentify() {
  const { data } = useSession();
  const pathname = usePathname();
  const user = data?.user;

  // Page event tracker which reports to analytics
  useEffect(() => {
    if (pathname) {
      routeChangeHandler(pathname);
    }
  }, [pathname]);

  useEffect(() => {
    if (user) {
      const { id, email, firstName, lastName, photoUrl } = user;
      const name = `${firstName} ${lastName}`;
      identify(id, {
        email,
        name,
        avatar: photoUrl,
      });

      // Track user in Datadog RUM
      datadogRum.setUser({
        email: email || '',
        name,
        id,
      });
    }
  }, [user]);

  return null;
}
